import { createFeatureSelector, createSelector } from '@ngrx/store';
import { searchFeatureKey, SearchState } from '@app2/store/search/search.reducer';

const selectState = createFeatureSelector<SearchState>(searchFeatureKey);

const selectFaps = createSelector(selectState, (state) => state.list);
const selectFapsIsLoading = createSelector(selectState, (state) => state.isLoading);
const selectFapsError = createSelector(selectState, (state) => state.error);
const selectFapsNextPage = createSelector(selectState, (state) => state.nextPage);
const selectQuery = createSelector(selectState, (state) => state.query);

export const searchSelectors = {
  selectFaps,
  selectFapsIsLoading,
  selectFapsError,
  selectFapsNextPage,
  selectQuery,
};

